import { render } from "./crossRecorders.vue?vue&type=template&id=73b13846&scoped=true&lang=pug"
import script from "./crossRecorders.vue?vue&type=script&setup=true&lang=js"
export * from "./crossRecorders.vue?vue&type=script&setup=true&lang=js"

import "./crossRecorders.vue?vue&type=style&index=0&id=73b13846&scoped=true&lang=css"

import exportComponent from "/Users/liu/Downloads/cross-bridge v0.1.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73b13846"]])

export default __exports__